import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import classnames from 'classnames';
import { generateFullName } from 'utils/badgeHelpers';
import { intervalToDuration } from 'date-fns';
import statusDescription from '../../../utils/statusDescription';
import { capitalize } from '../../../utils';
import { parseDateSafe } from '../../../utils/timeHelper';

const checkIsInactive = (status) => status?.includes('inactive');
const checkIsOnboarding = (status) => status?.includes('onboarding');
const checkIsReferralWithdraw = (status) =>
  status?.includes('referral_withdraw');
const checkIsPendingReview = (status) => status?.includes('pending_review');

const PatientNameBadge = ({ profile, patientDetailsLoading }) => {
  const { birthDate, title, firstName, lastName, middleName, status } = profile;
  const {
    isInactive,
    isOnboarding,
    isReferralWithdraw,
    isPendingReview,
    descriptionByStatus,
  } = useMemo(
    () => ({
      isInactive: checkIsInactive(status),
      isOnboarding: checkIsOnboarding(status),
      isReferralWithdraw: checkIsReferralWithdraw(status),
      isPendingReview: checkIsPendingReview(status),
      descriptionByStatus: statusDescription(status),
    }),
    [status],
  );
  const today = new Date();
  const endDate = parseDateSafe(profile?.holdingStatus?.endTime);

  const remainingDays =
    endDate &&
    intervalToDuration({
      start: today,
      end: endDate,
    })?.days;

  return (
    <div
      className={classnames(
        'name-badge',
        {
          'slide-in-badge': !patientDetailsLoading,
        },
        { 'slide-in-badge--inactive': isInactive },
        { 'slide-in-badge--onboarding': isOnboarding },
        { 'slide-in-badge--onboarding': isReferralWithdraw },
        { 'slide-in-badge--pending-review': isPendingReview },
      )}
    >
      {!patientDetailsLoading && (
        <>
          <div className="fullName">
            {generateFullName(title, firstName, middleName, lastName)} |{' '}
            {birthDate?.replaceAll('-', '/')}{' '}
            {profile.holdingStatus &&
              profile.holdingStatus?.status !== 'active' && (
                <>
                  |{' '}
                  <span>
                    {capitalize(profile.holdingStatus?.status)}: (
                    {remainingDays + 1} days)
                  </span>
                </>
              )}
          </div>
          {isInactive && (
            <div className="statusDescription">{descriptionByStatus}</div>
          )}
        </>
      )}
    </div>
  );
};

PatientNameBadge.defaultProps = {
  patientDetailsLoading: false,
};

PatientNameBadge.propTypes = {
  profile: PropTypes.shape().isRequired,
  patientDetailsLoading: PropTypes.bool,
};

export default PatientNameBadge;
